export default "__VITE_ASSET__viT3$_JV__"